import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import {
  lang,
  permissions,
  scssVariables as variables,
  upperFirstChar,
  withRouter
} from 'src/helpers';
import {
  MCButton,
  MCText,
  PopoverMenu,
  SearchTextField,
  TabMenu,
  ToggleSwitch,
  View
} from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { remCss } from 'src/helpers';
import model from './model';
import moment from 'moment/moment';
import AlertManager from 'src/components/alert/AlertManager';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import invitationsModel from './invitationsModel';
import { EmailPhone } from 'src/components/Form';

class Manager extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    invitationsModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    invitationsModel.unsubscribe(this.subscription);
  }
  onSearchTextChange = (text, model) => {
    model.setStateSilent({ search: text, pageIndex: 0 });
    model.handleChangeSearch(text);
    if (!text) {
      model.setListStateSilent({ items: [], total: 0 }, 'search');
      model.refresh();
    }
  };

  renderSearchHeader = (model) => {
    let canAdd = permissions.ACTIONS.SETTING_MANAGER_ADD_BUTTON.checkActive({
      auth: model.state?.user
    });
    return (
      <View
        style={{
          flexDirection: 'row',
          marginBottom: remCss(15),
          gap: remCss(15),
          flexWrap: 'wrap'
        }}
      >
        <SearchTextField
          template={'2'}
          width={300}
          placeholder={LANG_CONST.search}
          onChange={(text) => {
            this.onSearchTextChange(text, model);
          }}
          value={model.input('search')}
        />
        <View style={{ flex: 1 }} />
        {canAdd && (
          <div className={'mc-flex-col'}>
            <MCButton
              type={'link'}
              primary
              dark
              radius
              flex
              medium
              to={'/managers/add'}
              style={{ height: remCss(30) }}
              label={LANG_CONST.buttons.add_new}
            />
          </div>
        )}
      </View>
    );
  };

  renderManagers() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    const createState = model.getApiState('update');
    const medium = !this.props.screenDetail.isLargeScreen;

    let canEdit = permissions.ACTIONS.SETTING_MANAGER_EDIT_BUTTON.checkActive({
      auth: model.state?.user
    });
    let disabled = !canEdit;

    //Name | add date |  appointments| treatments | doctors |  admin | actions( remove)
    const columns = [
      {
        label: LANG_CONST.name,
        headerTooltip: LANG_CONST.name,
        sort: { sortKey: 'name' },
        minWidth: '120',
        resize: true,
        renderCell: (item) => {
          return (
            <ShortInfo
              user={item}
              description={<EmailPhone item={item} emailWeight={400} />}
              vertical
            />
          );
        }
      },
      !medium && {
        label: LANG_CONST.added_date,
        headerTooltip: LANG_CONST.added_date,
        resize: true,
        width: '10%',
        renderCell: (item) =>
          item.managerAddedDate ? moment(item.managerAddedDate).format('MM.DD.YYYY') : ''
      },
      {
        label: <div style={{ width: remCss(92), textAlign: 'center' }}>{LANG_CONST.admin}</div>,
        resize: true,
        headerTooltip: LANG_CONST.admin,
        width: `${remCss(112)}px`,
        renderCell: (item) => {
          return (
            <View style={{ gap: remCss(10), alignItems: 'center', width: remCss(92) }}>
              <ToggleSwitch
                className={disabled ? 'disabled' : ''}
                disabled={createState.loading || disabled}
                checked={model.checkWithUpdating(item, 'managerAdmin', item.managerAdmin)}
                onChange={() => model.admin(item)}
              />
            </View>
          );
        }
      },

      ...(!medium
        ? Object.keys(LANG_CONST.constants.manager_access).map((value) => ({
            label: LANG_CONST.constants.manager_access[value],
            resize: true,
            headerTooltip: LANG_CONST.constants.manager_access[value],
            width: '10%',
            renderCell: (item) => {
              const isActive = model.checkWithUpdating(
                item,
                value,
                item.managerAccess?.filter((a) => !!a[value])?.length === model.state.hospitalTotal
              );

              return (
                <ToggleSwitch
                  className={!item.managerActive || disabled ? 'disabled' : ''}
                  disabled={
                    !canEdit ||
                    createState.loading ||
                    !item.managerActive ||
                    item.managerAdmin ||
                    item.id === model.state.user?.id
                  }
                  checked={isActive}
                  onChange={() => model.accessAll(item, value, !isActive)}
                />
              );
            }
          }))
        : [
            {
              label: (
                <div style={{ width: remCss(280), textAlign: 'center' }}>{LANG_CONST.accesses}</div>
              ),
              resize: true,
              headerTooltip: LANG_CONST.accesses,
              width: `${remCss(280)}px`,
              renderCell: (item) => {
                return (
                  <View className={'mc-flex-col'}>
                    {Object.keys(LANG_CONST.constants.manager_access).map((value) => {
                      const isActive = model.checkWithUpdating(
                        item,
                        value,
                        item.managerAccess?.filter((a) => !!a[value])?.length ===
                          model.state.hospitalTotal
                      );

                      return (
                        <div className={'mc-flex-20'} key={value}>
                          <ToggleSwitch
                            className={!item.managerActive || disabled ? 'disabled' : ''}
                            disabled={
                              !canEdit ||
                              createState.loading ||
                              !item.managerActive ||
                              item.managerAdmin ||
                              item.id === model.state.user?.id
                            }
                            checked={isActive}
                            onChange={() => model.accessAll(item, value, !isActive)}
                          />
                          <div
                            onClick={() => {
                              if (
                                !canEdit ||
                                createState.loading ||
                                !item.managerActive ||
                                item.managerAdmin ||
                                item.id === model.state.user?.id
                              )
                                return null;
                              model.accessAll(item, value, !isActive);
                            }}
                          >
                            {lang.t(LANG_CONST.constants.manager_access[value])}
                          </div>
                        </div>
                      );
                    })}
                  </View>
                );
              }
            }
          ]),
      {
        label: (
          <div style={{ width: remCss(92), textAlign: 'center' }}>{lang.t(LANG_CONST.active)}</div>
        ),
        headerTooltip: LANG_CONST.active,
        resize: true,
        width: `${remCss(112)}px`,
        renderCell: (item) => {
          return (
            <View style={{ gap: remCss(10), alignItems: 'center', width: remCss(92) }}>
              <ToggleSwitch
                className={disabled ? 'disabled' : ''}
                disabled={createState.loading || disabled}
                checked={model.checkWithUpdating(item, 'managerActive', item.managerActive)}
                onChange={() => model.active(item)}
              />
            </View>
          );
        }
      },
      !medium && {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        minWidth: remCss(220),
        width: '10%',
        headerTooltip: LANG_CONST.actions,
        renderCell: this.renderManagerActions
      }
    ].filter((v) => !!v);

    return (
      <>
        {this.renderSearchHeader(model)}
        <TableLibrary
          loading={loading}
          noResults={noResults}
          searchQuery={searchQuery}
          className={medium && 'mc-row2'}
          renderExtend={
            medium
              ? (item) => {
                  return (
                    <div className={'mc-flex-20'}>
                      <MCText
                        flex
                        label={
                          lang.t(LANG_CONST.added_date) +
                          ': ' +
                          (item.managerAddedDate
                            ? moment(item.managerAddedDate).format('MM.DD.YYYY')
                            : '')
                        }
                      />
                      {this.renderManagerActions(item)}
                    </div>
                  );
                }
              : null
          }
          sortBy={model.state.sortBy}
          selectedPage={model.state.pageIndex}
          total={total}
          key={medium ? 1 : 0}
          limit={model.listLimit}
          onSortChange={(sortBy) => {
            model.handleChange('sortBy', sortBy);
            model.setListState({ items: [] }, model.getCurrentId(), null, true);
            model.loadMore();
          }}
          onSetPage={(v) => {
            model.handleChange('pageIndex', v);
            model.setListState({ items: [] }, model.getCurrentId(), null, true);
            model.loadMore();
          }}
          columns={columns}
          data={items}
          otherProps={{
            cell: () => ({
              style: {
                alignItems: 'flex-start'
              }
            })
          }}
        />
      </>
    );
  }

  renderManagerActions = (item) => {
    let canEdit = permissions.ACTIONS.SETTING_MANAGER_EDIT_BUTTON.checkActive({
      auth: model.state?.user
    });

    return !item.managerAccess?.includes('owner') && item.id !== model.state.user?.id ? (
      <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
        <MCButton
          label={LANG_CONST.buttons.locations}
          small
          radius
          primary
          dark
          onClick={() => {
            this.navigate(permissions.PAGES.MANAGERS_LOCATIONS_PAGE.match(item.id));
          }}
        />
        {canEdit && (
          <>
            <MCButton
              label={LANG_CONST.buttons.login}
              small
              radius
              primary
              dark
              onClick={() => {
                model.logAsManager(item);
              }}
            />

            <View style={{ minWidth: remCss(24) }}>
              <PopoverMenu
                arrowOffset={30}
                placement={'bottom-end'}
                popupMenuStyle={{
                  backgroundColor: 'white',
                  padding: remCss(10),
                  overflow: 'none'
                }}
                menu={() => (
                  <>
                    <MCButton
                      iconname={BASE_ICONS.DELETE}
                      width={42}
                      light
                      radius
                      secondary
                      padding={5}
                      onClick={(e) => {
                        e.preventDefault();
                        AlertManager.popup(AlertManager.TYPES.WARN, {
                          close: false,
                          title: LANG_CONST.notice.delete,
                          cancelButton: {
                            label: LANG_CONST.buttons.no,
                            action: (actions) => actions.hide()
                          },
                          actionButton: {
                            label: LANG_CONST.buttons.yes,
                            action: (actions) => {
                              actions.setLoading(true);
                              model.remove(item, () => {
                                actions.setLoading(false);
                                actions.hide();
                              });
                            }
                          }
                        });
                      }}
                    />
                  </>
                )}
                className={'mc-pointer mc-flex mc-flex-center'}
              >
                {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={24} />}
              </PopoverMenu>
            </View>
          </>
        )}
      </div>
    ) : item.id === item.managerToClinic ? (
      lang.t('Owner')
    ) : (
      ''
    );
  };

  renderInvitations = () => {
    let loading = invitationsModel.refreshing();
    let noResults = invitationsModel.noResults();
    let searchQuery = invitationsModel.listInput('search');
    let items = invitationsModel.items();
    let { total = 0 } = invitationsModel.getCurrent();
    const auth = invitationsModel.state.user || {};
    const medium = !this.props.screenDetail?.isLargeScreen;

    const columns = [
      {
        label: LANG_CONST.name,
        resize: true,
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <ShortInfo
              user={item}
              fullname={item.fullname}
              vertical={medium}
              description={medium && <EmailPhone item={item} emailWeight={400} />}
            />
          </div>
        )
      },
      !medium && {
        label: LANG_CONST.email_phone,
        resize: true,
        minWidth: '250',
        width: '25%',
        renderCell: (item) => <EmailPhone item={item} />
      },
      {
        label: LANG_CONST.added_date,
        resize: true,
        minWidth: '150',
        width: '20%',
        renderCell: (item) => (item.date ? moment(item.date).format('DD.MM.YYYY') : null)
      },
      {
        label: LANG_CONST.status,
        resize: true,
        minWidth: '120',
        width: '15%',
        renderCell: (item) => (
          <button className={'mc-status-' + item.status}>
            {lang.t(upperFirstChar(item.status))}
          </button>
        )
      },
      {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        minWidth: '150',
        width: '15%',
        renderCell: (item) => {
          const canEdit = permissions.PAGES.DOCTORS_EDIT_PAGE.checkActive({
            auth,
            doctor: item
          });
          return (
            <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
              {item.status !== 'accepted' && (
                <MCButton
                  primary
                  light
                  radius
                  medium
                  padding={1}
                  style={{
                    paddingHorizontal: remCss(9),
                    paddingVertical: remCss(5.5),
                    fontWeight: 400
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    AlertManager.popup(AlertManager.TYPES.INFO, {
                      close: false,
                      title: LANG_CONST.notice.resend,
                      cancelButton: {
                        label: LANG_CONST.buttons.no,
                        action: (actions) => actions.hide()
                      },
                      actionButton: {
                        label: LANG_CONST.buttons.yes,
                        action: (p) => {
                          p.setLoading(true);
                          invitationsModel.resend(item.id, (err) => {
                            p.setLoading(false);
                            if (!err)
                              AlertManager.popup(AlertManager.TYPES.INFO, {
                                close: false,
                                width: 450,
                                title: lang.t(LANG_CONST.notice.sent_invitation, {
                                  type: lang.t(LANG_CONST.patient).toLowerCase()
                                }),
                                actionButton: {
                                  label: LANG_CONST.buttons.ok,
                                  action: (actions) => {
                                    actions.hide();
                                  }
                                }
                              });
                          });
                        }
                      }
                    });
                  }}
                >
                  <span style={{ fontWeight: 400, fontFamily: variables['fonts-mc-regular'] }}>
                    {lang.t(LANG_CONST.buttons.resend)}
                  </span>
                </MCButton>
              )}
              {canEdit && (
                <View style={{ minWidth: remCss(24) }}>
                  <PopoverMenu
                    arrowOffset={30}
                    placement={'bottom-end'}
                    popupMenuStyle={{
                      backgroundColor: 'white',
                      padding: remCss(10),
                      overflow: 'none'
                    }}
                    menu={() => (
                      <>
                        <MCButton
                          iconname={BASE_ICONS.DELETE}
                          width={42}
                          light
                          radius
                          secondary
                          padding={5}
                          onClick={(e) => {
                            e.preventDefault();
                            AlertManager.popup(AlertManager.TYPES.WARN, {
                              close: false,
                              title: LANG_CONST.notice.delete,
                              cancelButton: {
                                label: LANG_CONST.buttons.no,
                                action: (actions) => actions.hide()
                              },
                              actionButton: {
                                label: LANG_CONST.buttons.yes,
                                action: (actions) => {
                                  actions.setLoading(true);
                                  invitationsModel.remove(item, () => {
                                    actions.setLoading(false);
                                    actions.hide();
                                  });
                                }
                              }
                            });
                          }}
                        />
                      </>
                    )}
                    className={'mc-pointer mc-flex mc-flex-center'}
                  >
                    {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={24} />}
                  </PopoverMenu>
                </View>
              )}
            </div>
          );
        }
      }
    ].filter((c) => !!c);

    return (
      <>
        {this.renderSearchHeader(invitationsModel)}
        <TableLibrary
          otherProps={{
            cell: () => ({
              style: {
                alignItems: 'flex-start'
              }
            })
          }}
          loading={loading}
          noResults={noResults}
          searchQuery={searchQuery}
          sortBy={invitationsModel.state.sortBy}
          selectedPage={invitationsModel.state.pageIndex}
          total={total}
          limit={invitationsModel.listLimit}
          onSortChange={(sortBy) => {
            invitationsModel.handleChange('sortBy', sortBy);
            invitationsModel.setListState(
              { items: [] },
              invitationsModel.getCurrentId(),
              null,
              true
            );
            invitationsModel.loadMore();
          }}
          onSetPage={(v) => {
            invitationsModel.handleChange('pageIndex', v);
            invitationsModel.setListState(
              { items: [] },
              invitationsModel.getCurrentId(),
              null,
              true
            );
            invitationsModel.loadMore();
          }}
          key={medium ? 1 : 0}
          columns={columns}
          data={items}
        />
      </>
    );
  };

  render() {
    return (
      <div className={'mc-container-content'} style={this.props.isSetting ? { padding: 0 } : {}}>
        {!this.props.isSetting && (
          <div className={'mc-container-content__header'}>
            <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.managers)}</span>
          </div>
        )}
        <div className={'mc-container-content__body'} style={{ zIndex: 0 }}>
          <div className={'mc-container-content__body-header'}>
            <div className={'mc-grow'}>
              <TabMenu
                tabs={[
                  { id: 'managers', name: LANG_CONST.titles.managers },
                  {
                    id: 'invitations',
                    name: LANG_CONST.invitations
                  }
                ]}
                tab={{ id: model.input('tab') }}
                setTab={(tab) => {
                  if (tab.id === model.input('tab')) {
                    model.setListStateSilent({ items: [] });
                    model.loadMore();
                  }
                  model.setState({ tab: tab.id });
                }}
                type={'panner'}
              />
            </div>
          </div>

          <div className={'mc-tab-box-opacity mc-grow'}>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') === 'managers' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-container-content__body-content'}>{this.renderManagers()}</div>
            </div>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') !== 'managers' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-container-content__body-content'}>{this.renderInvitations()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Manager);
